import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import moment from "moment";
import { debounceTime } from "rxjs/operators";
import { ICancelamentoAgendamento, IGetAgendamento } from "src/app/services/AgendamentoService/agendamento.model";
import { AgendamentoService } from "src/app/services/AgendamentoService/agendamento.service";
import { AppExportBase64 } from "src/app/services/ExportBase64/exportBase64.service";
import {
  IGetReportBase64,
  IReportAgendamentoFilterParams,
} from "src/app/services/ReportService/report.model";
import { ReportService } from "src/app/services/ReportService/report.service";
import { IGetServico } from "src/app/services/ServicoService/servico.model";
import { ServicoService } from "src/app/services/ServicoService/servico.service";
import { ITabelaAgendamento } from "./listagem-agendamento.model";
import {
  formatarDataSemHorario,
  formatarFiltroDataApi,
  formatarPlaca,
} from "src/app/core/utils/utilities";
import { HubConnectionService } from "src/app/services/HubConnectionService/hubConnection.service";
import Swal from "sweetalert2";
import { SwalAlertService } from "src/app/services/SwalAlertService/swalAlert.service";

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: "app-listagem-agendamento",
  templateUrl: "./listagem-agendamento.component.html",
  styleUrls: ["./listagem-agendamento.component.scss"],
})
export class ListagemAgendamentoComponent implements OnInit, AfterViewInit {
  blobUrl: string = "";
  isLoading: boolean = false;
  form = this._inicializarFormulario();
  tableData: ITabelaAgendamento[] | Array<any> = [];
  pesquisaParams = {
    TxPesquisar: "",
    DtInicio: "",
    DtFim: "",
    Pagina: 0,
    TamanhoPagina: 20,
  };
  solicitarAgendamento: boolean = false;
  maxPages: number = 0;
  numeroPagina: number = 0;

  expandirCardsMobile: boolean = true;

  servicoOptions: IOptions[] = [
    {
      name: "",
      value: "",
    },
  ];

  statusOptions: IOptions[] = [
    { name: "Todos", value: "" },
    { name: "Aguardando Pagamento", value: 0 },
    { name: "Agendado", value: 1 },
    { name: "Concluído", value: 2 },
    { name: "Cancelado", value: 3 },
    { name: "Expirado", value: 4 },
    { name: "Bloqueado", value: 5 },
    { name: "Parcialmente Concluído", value: 6 },
    { name: "Perdido", value: 7 },
  ];

  tableColumns = [
    { header: "Código", key: "codigo", type: "text" },
    { header: "Agendamento", key: "agendamento", type: "text" },
    { header: "Tipo de Serviço", key: "tipoServico", type: "text" },
    { header: "Placa do Cavalo", key: "placaCavalo", type: "text" },
    { header: "Motorista", key: "motorista", type: "text" },
    { header: "Nota Fiscal", key: "notaFiscal", type: "text" },
    { header: "Janela", key: "janela", type: "text" },
    { header: "Destinatário", key: "destinatario", type: "text" },
    {
      header: "Situação",
      key: "situacao",
      type: "text",
      pipe: {
        transform: (value: string): any => this.obterCorStatus(value)
      }
    },
    {
      header: "Ações",
      key: "actions",
      type: "buttons",
      buttons: [
        {
          label: "Visualizar",
          img: "assets/eye-icon.png",
          action: (item: any) => this.visualizarAgendamento(item),
          condition: (item: any) => true,
        },
        {
          label: "Entrar",
          img: "assets/icons/entrada-gate-black.svg",
          action: (item: any) => this.EntradaPorAgendamento(item),
          condition: (item: any) =>
            item.situacao === "Agendado" || item.situacao === "Parcialmente Concluído",
        },
        // {
        //   label: 'Ticket',
        //   img: 'assets/icon-download.svg',
        //   action: (item: any) => this.exportPdf(Number(item.codigo)),
        //   condition: (item: any) => this.ticketAgendamento(item)
        // }
      ],
    },
  ];

  hubName = "pingHubPointing";
  hubReceiveName = "pingHubPointingReceive";

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private agendamentoService: AgendamentoService,
    private servicoService: ServicoService,
    private reportService: ReportService,
    private appExportBase64: AppExportBase64,
    private hubConnectionService: HubConnectionService,
    public swalAlertService: SwalAlertService,
  ) {}

  private _inicializarFormulario() {
    return this.fb.group({
      DT_AGND_INIC: [null],
      DT_AGND_FIM: [null],
      TX_PLCA_CAVA: [null],
      NM_MTRT: [null],
      FK_SRVC: [null as number | null],
      NU_STTS_AGND: [null as number | null],
    });
  }

  ngOnInit(): void {
    this.getAgendamento();
    this.getServico();

    this.hubConnectionService.configureHub(this.hubName, this.hubReceiveName);
    this.hubConnectionService.getMessages().subscribe((msg) => {
      this.swalAlertService.showAlert("Pagamento realizado com sucesso!", msg.message, "success");
      this.getAgendamento();
    });
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getAgendamento();
    });

    const role = localStorage.getItem("role");

    if (role !== "interno") {
      this.tableColumns.map((column) => {
        if (column.type === "buttons") {
          const buttons = column.buttons;
          if (buttons !== undefined) {
            buttons.push(
              {
                label: "Editar",
                img: "assets/edit.svg",
                action: (item: any) => this.editarAgendamento(item),
                condition: (item: any) => this.podeEditarAgendamento(item),
              },
              {
                label: "Pagamento",
                img: "assets/money-icon.svg",
                action: (item: any) => this.pagarAgendamento(item),
                condition: (item: any) => this.pagamentoAgendamento(item),
              },
            );
          }
        }
      });

      this.solicitarAgendamento = true;
    }
  }

  navegarAgendamento() {
    this.router.navigate(["cadastro/agendamento"]);
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.numeroPagina = pagina;
    this.getAgendamento(pagina + 1);
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === "" ? "Não Informado" : String(campo);
  }

  getHours(date: Date) {
    if (date !== null) {
      return moment(date).format("HH:mm");
    }
    return "******";
  }

  getDate(date: Date) {
    if (date !== null) {
      return moment(date).format("DD/MM/YYYY");
    }
    return "******";
  }

  obterCorStatus(status: string) {
    const statusMap: Record<string, string> = {
      "Aguardando Pagamento": "status-amarelo",
      "Agendado": "status-verde",
      "Expirado": "status-vermelho",
      "Cancelado": "status-cinza",
      "Bloqueado": "status-vermelho",
      "Concluído": "status-roxo",
      "Parcialmente Concluído": "status-azul",
      "Perdido": "status-marrom"
    };
    return {
      text: status,
      className: `status-badge ${statusMap[status] || "status-cinza"}`
    };
  }

  getAgendamento(pagina?: number) {
    this.isLoading = true;
    const payload = this.createPayload();

    this.agendamentoService
      .GetAgendamentoEmpresa({
        dtInicio: formatarFiltroDataApi(payload.DT_AGND_INIC),
        dtFim: formatarFiltroDataApi(payload.DT_AGND_FIM),
        fkServico: Number(payload.FK_SRVC),
        nmMotorista: payload.NM_MTRT ?? "",
        placaCavalo: payload.TX_PLCA_CAVA ?? "",
        nuStatusAgendamento: payload.NU_STTS_AGND ?? undefined,
        pageNumber: pagina ?? 1,
        pageSize: 20,
      })
      .subscribe({
        next: (response: IGetAgendamento) => {
          this.isLoading = false;
          this.tableData = response.ITEMS.map((item) => {
            const placas = [];

            if (item.TX_PLCA_CRRT_1 !== null) placas.push(item.TX_PLCA_CRRT_1);
            if (item.TX_PLCA_CRRT_2 !== null) placas.push(item.TX_PLCA_CRRT_2);
            if (item.TX_PLCA_CRRT_3 !== null) placas.push(item.TX_PLCA_CRRT_3);

            const placaCarreta = placas.join(" | ");

            this.maxPages = response.TOTAL_PAGES;

            const hrInic = (item.HR_INIC_JNLA ?? "").toString().substring(0, 5);
            const hrFim = (item.HR_FIM_JNLA ?? "").toString().substring(0, 5);
            const janela =
              hrInic && hrFim ? `${hrInic} - ${hrFim}` : hrInic || "---";

            return {
              codigo: item.PK_AGND ?? "---",
              agendamento: formatarDataSemHorario(item.DT_AGND),
              tipoServico: item.TX_TIPO_SRVC ?? "---",
              placaCavalo: formatarPlaca(item.TX_PLCA_CAVA) ?? "---",
              placaCarreta: formatarPlaca(placaCarreta) ?? "---",
              motorista: item.NM_MTRT ?? "---",
              destinatario: item.NM_DTNR ?? "---",
              notaFiscal: item.TX_NOTA_FISCAL ?? "---",
              janela,
              situacao: item.NM_STTS_AGND ?? "---",
              dataAgendamento: item.DT_AGND ?? "---",
              valorServico: "7,00",
            };
          });
        },
        error: (_error: any) => {
          this.isLoading = false;
        },
      });
  }

  createPayload() {
    const payload = { ...this.form.value };
    (Object.keys(payload) as (keyof typeof payload)[]).forEach((key) => {
      if (payload[key] === null) {
        delete payload[key];
      }
    });
    return payload;
  }

  editarAgendamento(item: any) {
    this.router.navigate(["cadastro/agendamento"], {
      queryParams: { codigo: item.codigo, modoAgendamento: "Editar" },
    });
  }

  pagarAgendamento(item: any) {
    const queryParams = {
      PK_AGND: item.codigo,
      VL_SRVC: item.valorServico,
    };

    this.router.navigate(["pagamento"], {
      queryParams: queryParams,
    });
  }

  visualizarAgendamento(item: any) {
    this.router.navigate(["cadastro/agendamento"], {
      queryParams: { codigo: item.codigo, modoAgendamento: "Visualizar" },
    });
  }

  EntradaPorAgendamento(item: any) {
    this.router.navigate(["cadastro/entrada"], {
      queryParams: {
        idAgendamento: item.codigo,
        isMode: 0,
      },
    });
  }

  getServico(): void {
    this.servicoService.GetServico(true).subscribe((response) => {
      this.servicoOptions = [
        { name: "Selecione", value: null },
        ...response.map((x: IGetServico) => ({
          name: x.TX_TIPO_SRVC,
          value: x.PK_SRVC,
        })),
      ];
    });
  }

  escolherServico(value: any): void {
    if (this.form.controls["FK_SRVC"].value !== value) {
      this.form.controls["FK_SRVC"].setValue(value, { emitEvent: false });
      this.getAgendamento();
    }
  }

  private buildReportAgendamentoFilterParams(): IReportAgendamentoFilterParams {
    const p = this.createPayload() as Record<string, unknown>;
    const o: IReportAgendamentoFilterParams = {};
    const dtInic = formatarFiltroDataApi(p["DT_AGND_INIC"] as string);
    const dtFim = formatarFiltroDataApi(p["DT_AGND_FIM"] as string);
    if (dtInic) {
      o.DT_AGND_INIC = dtInic;
    }
    if (dtFim) {
      o.DT_AGND_FIM = dtFim;
    }
    const fk = Number(p["FK_SRVC"]);
    if (!Number.isNaN(fk) && fk > 0) {
      o.FK_SRVC = fk;
    }
    if (p["NM_MTRT"] && String(p["NM_MTRT"]).trim()) {
      o.NM_MTRT = String(p["NM_MTRT"]).trim();
    }
    const placa = p["TX_PLCA_CAVA"]
      ? String(p["TX_PLCA_CAVA"]).replace(/-/g, "").trim()
      : "";
    if (placa) {
      o.TX_PLCA_CAVA = placa;
    }
    return o;
  }

  exportarExcel() {
    this.isLoading = true;

    this.reportService
      .GetAgendamentoFilter(this.buildReportAgendamentoFilterParams())
      .subscribe({
        next: (response: IGetReportBase64) => {
          this.appExportBase64.downloadExcel(
            response.ReportBase64,
            "Agendamento"
          );

          this.isLoading = false;
        },
        error: (_error) => {
          this.isLoading = false;
        },
      });
  }

  /** Edição permitida até 24h antes do horário do agendamento, exceto status finais. 
   *  Permite editar agendamentos 'Perdido' para reabertura.
   */
  podeEditarAgendamento(item: any): boolean {
    if (item.situacao === "Perdido") return true;

    if (
      item.situacao === "Cancelado" ||
      item.situacao === "Concluído" ||
      item.situacao === "Parcialmente Concluído"
    ) {
      return false;
    }
    const dt = new Date(item.dataAgendamento);
    if (Number.isNaN(dt.getTime())) {
      return false;
    }
    const now = new Date();
    const limiteHoras = 24;
    const limite = new Date(dt.getTime() - limiteHoras * 60 * 60 * 1000);
    return now < limite;
  }

  cancelamentoStatus(item: any): boolean {
    if (item.situacao == "Cancelado") return false;
    if (item.situacao == "Concluído" || item.situacao == "Parcialmente Concluído")
      return false;

    return true;
  }

  pagamentoAgendamento(item: any): boolean {
    if (item.situacao !== "Aguardando Pagamento") {
      return false;
    }

    const dataAgendamento = new Date(item.dataAgendamento);
    if (new Date() > dataAgendamento) {
      return false;
    }

    return true;
  }

  ticketAgendamento(item: any): boolean {
    if (item.situacao == "Agendado") {
      return true;
    }

    return false;
  }

  cancelarAgendamento(item: any) {
    const body: ICancelamentoAgendamento = {
      PK_AGND: item.codigo,
    };

    this.swalAlertService.showAlert(
      "Atenção",
      "Caso tenha sido feito o pagamento, não será reembolsado. Deseja prosseguir?",
      "warning",
      true,
      true,
      undefined,
      () => {
        this.isLoading = true;

        this.agendamentoService.CancelamentoAgendamento(body).subscribe({
          next: () => {
            this.swalAlertService.showAlert("Cancelado", "Cancelamento realizado com sucesso.", "success");
            this.getAgendamento();
          },
          error: (err) => {
            this.swalAlertService.handleError(
              err,
              "Atenção",
              "Ocorreu um erro ao realizar o cancelamento, por favor, tente novamente.",
              "warning",
            );
            this.isLoading = false;
          },
        });
      },
    );
  }

  exportPdf(id: number) {
    this.isLoading = true;

    this.agendamentoService.GetReceiptAgendamentoById(id).subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadPDF(response.ReportBase64, "ticket");
        this.isLoading = false;
      },
      error: (_error) => {
        this.isLoading = false;
      },
    });
  }
}

